import React, { useEffect, useState } from "react";
import {
    Col,
    Container,
} from "reactstrap";
import axios from "axios";
import NewApkModal from "../Modals/NewApkModal.js";

const IXIPLACE = () => {

    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const [apkList, setApkList] = useState([]);

    useEffect(() => {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        if (authUser) {
            setIsSuperAdmin(authUser.user_ROLE_ID === 1);
        }
        fetchApkList();
    }, []);

    const fetchApkList = async () => {
        try {
            const res = await axios.get("/api/upload/apk-list", { withCredentials: true });
            setApkList(Array.isArray(res) ? res : []);
        } catch (error) {
            console.error("Erreur récupération liste APK", error);
        }
    };

    const handleDownload = (fileName) => {
        const url = `/api/upload/download-apk/${fileName}`;
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleDeleteApk = async (apk) => {
        if (!window.confirm(`Voulez-vous vraiment supprimer l'APK "${apk.apk_NAME}" ?`)) return;
        try {
            await axios.delete(`/api/upload/apk/${apk.apk_ID}`, { withCredentials: true });
            setApkList((prev) => prev.filter((a) => a.apk_ID !== apk.apk_ID));
        } catch (error) {
            console.error("Erreur suppression APK", error);
            alert("Erreur lors de la suppression de l'APK");
        }
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Col lg={12}>
                        <div classname="card">
                            <div className="card-body">
                                <h1 className="text-primary text-center">iXiPLACE</h1>
                                <h2 className="text-tertiary text-center">Téléchargement APK</h2>
                                <p className="text-muted mb-2 text-center">Application XR de spatialisation de contenus XR</p>
                            </div>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                {isSuperAdmin && (
                                    <div className="d-flex justify-content-end mb-3">
                                        <NewApkModal onApkAdded={fetchApkList} />
                                    </div>
                                )}
                                <div className="table-responsive">
                                    <table className="table table-centered table-nowrap mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">Modèle supporté</th>
                                                <th scope="col">Description</th>
                                                <th scope="col">Nom</th>
                                                <th scope="col">Version</th>
                                                <th scope="col" style={{ width: "100px" }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {apkList.map((apk) => (
                                                <tr key={apk.apk_ID}>
                                                    <td>{apk.apk_MODEL}</td>
                                                    <td>{apk.apk_DESCRIPTION}</td>
                                                    <td>{apk.apk_NAME}</td>
                                                    <td>{apk.apk_VERSION}</td>
                                                    <td>
                                                        <button
                                                            title="Télécharger l'APK"
                                                            className="btn btn-sm btn-outline-primary fs-4 py-0 px-1 me-2"
                                                            onClick={() => handleDownload(apk.apk_FILENAME)}
                                                        >
                                                            <i className="mdi mdi-download"></i>
                                                        </button>
                                                        {isSuperAdmin && (
                                                            <button
                                                                title="Supprimer l'APK"
                                                                className="btn btn-sm btn-outline-danger fs-4 py-0 px-1"
                                                                onClick={() => handleDeleteApk(apk)}
                                                            >
                                                                <i className="mdi mdi-trash-can-outline"></i>
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </Col>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default IXIPLACE;

//Creators : Florian Cohen-Joly @3DDGAMES -- Under license
